import { useAuthStore } from '@/stores/auth.ts'

export function setupRouterGuards(router) {
  // 添加一个标志来确保 checkAuth 只在应用初始化时调用一次
  let authChecked = false

  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    
    // 首次进入应用时检查认证状态
    if (!authChecked) {
      await authStore.checkAuth()
      authChecked = true
    }
    
    // 检查是否需要认证
    if (to.meta.requiresAuth) {
      if (!authStore.isAuthenticated) {
        next('/login')
        return
      }
    }
    
    // 如果已登录用户访问登录/注册/首页，重定向到仪表板
    if ((to.name === 'Login' || to.name === 'Register' || to.name === 'Home') && authStore.isAuthenticated) {
      next('/dashboard')
      return
    }
    
    next()
  })
}